
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eX8yE", function(module, exports) {

$parcel$export(module.exports, "DIALOG_SUBMIT_BTN", () => $bb299f6fd3832031$export$7a6a15706decd0f9);
$parcel$export(module.exports, "safeUnbindDomEvent", () => $bb299f6fd3832031$export$582c70653d60fda9);
$parcel$export(module.exports, "safeBindDomEvent", () => $bb299f6fd3832031$export$8e05e1932c4b20b0);
$parcel$export(module.exports, "default", () => $bb299f6fd3832031$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $hrKgE = parcelRequire("hrKgE");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $keOPi = parcelRequire("keOPi");

var $d2AGn = parcelRequire("d2AGn");

var $eDOqM = parcelRequire("eDOqM");

var $3ibpe = parcelRequire("3ibpe");

var $8oKDI = parcelRequire("8oKDI");

var $814y1 = parcelRequire("814y1");

var $gCeeo = parcelRequire("gCeeo");

var $gPQL9 = parcelRequire("gPQL9");



var $FMOPx = parcelRequire("FMOPx");

var $6gASS = parcelRequire("6gASS");

var $kVuBT = parcelRequire("kVuBT");
const $bb299f6fd3832031$export$7a6a15706decd0f9 = '#issue-workflow-transition-submit';
const $bb299f6fd3832031$export$582c70653d60fda9 = (selector, event, handler)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.removeEventListener(event, handler);
};
const $bb299f6fd3832031$export$8e05e1932c4b20b0 = (selector, event, handler)=>{
    $bb299f6fd3832031$export$582c70653d60fda9(selector, event, handler);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.addEventListener(event, handler);
};
const $bb299f6fd3832031$var$StatusServiceNew = ({ value: propValue, initialValue: initialValue, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEditCancel: onEditCancel = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), children: children, ...unstableProps })=>{
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, (0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    const [stateValue, setStateValue] = (0, $eJOHy.useState)(()=>{
        const value = propValue || initialValue;
        if (!value) throw new Error('Either value or initialValue prop is required.');
        return value;
    });
    const [lastSavedValue, setLastSavedValue] = (0, $eJOHy.useState)(stateValue);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [stateError, setError] = (0, $eJOHy.useState)(null);
    // These are unused but we are keeping parity with the class component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDialogOpened, setIsDialogOpened] = (0, $eJOHy.useState)(false);
    // These are unused but we are keeping parity with the class component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDialogConfirmPressed, setIsDialogConfirmPressed] = (0, $eJOHy.useState)(false);
    /**
	 * Equivalent to getDerivedStateFromProps in class component version.
	 *
	 * Lets the consumer control the value of this component. If the consumer passes a `value` prop
	 * it will override the value in state, as long as the component is not in loading state. That's because the component
	 * will only let the consumer know about the new status value once the transition is complete (i.e. loading=false).
	 *
	 * This lifecycle method gets called before every invocation of render().
	 */ const value = (0, $eJOHy.useMemo)(()=>{
        if (loading || !propValue) return stateValue;
        return propValue;
    }, [
        loading,
        propValue,
        stateValue
    ]);
    // componentDidUpdate
    const prevInitialValueRef = (0, $eJOHy.useRef)(initialValue);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const prevInitialValue = prevInitialValueRef.current;
        const newInitialValue = initialValue;
        const isNewStatus = newInitialValue && prevInitialValue && prevInitialValue.id !== newInitialValue.id && newInitialValue.id !== value.id;
        const hasNameChanged = newInitialValue && prevInitialValue && prevInitialValue.name !== newInitialValue.name;
        const hasCategoryChanged = newInitialValue && prevInitialValue && prevInitialValue.statusCategory.id !== newInitialValue.statusCategory.id;
        if (isNewStatus || props.checkRefreshedData && (hasNameChanged || hasCategoryChanged)) {
            setLoading(false);
            setStateValue(newInitialValue);
        }
        prevInitialValueRef.current = newInitialValue;
    }, [
        initialValue,
        props.checkRefreshedData,
        value.id
    ]);
    const onClickDialogConfirm = (0, $eJOHy.useCallback)(()=>{
        setIsDialogConfirmPressed(true);
    }, []);
    const bindDialogFormHandlers = (0, $eJOHy.useCallback)(()=>{
        $bb299f6fd3832031$export$8e05e1932c4b20b0($bb299f6fd3832031$export$7a6a15706decd0f9, 'click', onClickDialogConfirm);
    }, [
        onClickDialogConfirm
    ]);
    const unbindDialogFormHandlers = (0, $eJOHy.useCallback)(()=>{
        $bb299f6fd3832031$export$582c70653d60fda9($bb299f6fd3832031$export$7a6a15706decd0f9, 'click', onClickDialogConfirm);
    }, [
        onClickDialogConfirm
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // componentDidMount
        const onDialogContentReady = ()=>{
            // Using setTimeout as that was the class component version - this may need to be changed for concurrent
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                bindDialogFormHandlers();
                setIsDialogOpened(true);
                setIsDialogConfirmPressed(false);
            });
        };
        const handleBeforeDialogHide = ()=>{
            unbindDialogFormHandlers();
            setIsDialogOpened(false);
            setIsDialogConfirmPressed(false);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', handleBeforeDialogHide);
        return ()=>{
            // componentWillUnmount
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('legacyJiraDialogContentReady', onDialogContentReady);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('legacyJiraDialogBeforeHide', handleBeforeDialogHide);
            unbindDialogFormHandlers();
        // this.isDialogOpened = false; // we dont need to change the state since we are unmounting
        };
    }, [
        bindDialogFormHandlers,
        unbindDialogFormHandlers
    ]);
    const resetError = (0, $eJOHy.useCallback)(()=>{
        setError(null);
    }, []);
    const submit = (0, $eJOHy.useCallback)((transition, event)=>{
        const oldValue = value;
        const newValue = transition.to;
        const isEditFromIssueView = (0, $eDOqM.getIsEditFromIssueView)(event);
        const issueAri = props.issueId;
        const issueId = issueAri && (0, $8oKDI.isAri)(issueAri) ? (0, $8oKDI.getAriConfig)(issueAri).resourceId : issueAri;
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $814y1.STATUS_TYPE), {
            analytics: event,
            attributes: {
                fieldType: (0, $814y1.STATUS_TYPE),
                // Disabling typechange to keep parity
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                oldValId: oldValue.statusId ?? oldValue.id,
                newValId: newValue.id,
                oldStatusCategoryId: oldValue.statusCategory.id,
                newStatusCategoryId: newValue.statusCategory.id,
                isInlineEditing: !isEditFromIssueView,
                issueId: issueId
            }
        });
        setLoading(true);
        setStateValue(newValue);
        onSubmit(oldValue, newValue, {
            transition: transition
        }, event);
    }, [
        value,
        onSubmit,
        props.issueId
    ]);
    const success = (0, $eJOHy.useCallback)(({ status: status, event: event, viaDialog: viaDialog = false })=>{
        setLoading(false);
        setLastSavedValue(status);
        props.fieldValueActions.setFieldValue(props.issueKey, (0, $814y1.STATUS_TYPE), status);
        onSuccess(status, viaDialog, event);
        if ((0, $7jTnu.fg)('fix-status-field-loading-issue')) props.workflowTransitionsActions.setTransitionInProgress(false);
        (0, $gCeeo.fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
        (0, $3ibpe.sendExperienceAnalytics)((0, $FMOPx.transitionIssueExperienceDescription)(true, 'POST', props.source ?? '', props.projectType));
    }, [
        onSuccess,
        props.fieldValueActions,
        props.issueKey,
        props.projectType,
        props.source,
        props.workflowTransitionsActions
    ]);
    const failure = (0, $eJOHy.useCallback)((error, event)=>{
        setError(error);
        setLoading(false);
        setStateValue(lastSavedValue || propValue || initialValue);
        onFailure(error);
        if ((0, $7jTnu.fg)('fix-status-field-loading-issue')) props.workflowTransitionsActions.setTransitionInProgress(false);
        const isValidationError = error instanceof (0, $1uIew.ValidationError);
        if (isValidationError) props.flagService.showFlag((0, $kVuBT.default)(error.message));
        else props.flagService.showFlag((0, $6gASS.default)({
            error: error,
            traceId: error.traceId
        }));
        (0, $gCeeo.fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
            validationError: isValidationError,
            isClientFetchError: (0, $8KUFq.isClientFetchError)(error)
        });
        (0, $3ibpe.sendExperienceAnalytics)((0, $FMOPx.transitionIssueExperienceDescription)(false, 'POST', props.source ?? '', props.projectType, error.message, error.traceId, error.statusCode, (0, $gPQL9.isAbortableError)(error) && (0, $7jTnu.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail'));
    }, [
        initialValue,
        lastSavedValue,
        onFailure,
        propValue,
        props.flagService,
        props.projectType,
        props.source,
        props.workflowTransitionsActions
    ]);
    const cancel = (0, $eJOHy.useCallback)(()=>{
        setLoading(false);
        // @ts-expect-error - TS2322 - Type 'Status | undefined' is not assignable to type 'Status'.
        setStateValue(propValue || initialValue);
        onEditCancel();
        props.workflowTransitionsActions.setTransitionInProgress(false);
    }, [
        initialValue,
        onEditCancel,
        propValue,
        props.workflowTransitionsActions
    ]);
    const transitionStatus = (0, $eJOHy.useCallback)(async (transition, event)=>{
        const { appearance: appearance, issueKey: issueKey, renderIssueTransitionModal: renderIssueTransitionModal, renderIssueTransitionSuccessFlag: renderIssueTransitionSuccessFlag } = props;
        const newStatus = transition.to;
        submit(transition, event);
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>{
                    (0, $gCeeo.fireTrackAnalytics)(event, 'issueTransition success', {
                        triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                    (0, $7jTnu.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                    return success({
                        status: newStatus,
                        event: event,
                        viaDialog: true
                    });
                };
                const handleDialogCancel = ()=>{
                    (0, $gCeeo.fireTrackAnalytics)(event, 'issueTransition cancel', {
                        triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                    return cancel();
                };
                const handleDialogError = ()=>{
                    (0, $gCeeo.fireTrackAnalytics)(event, 'issueTransition failed', {
                        triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                };
                if (renderIssueTransitionModal) {
                    const { issueId: issueId } = props;
                    renderIssueTransitionModal({
                        payload: {
                            issueId: issueId,
                            issueKey: issueKey,
                            transitionId: transition.id
                        },
                        triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                        onDialogSuccess: handleDialogSuccess,
                        onDialogCancel: handleDialogCancel,
                        onDialogError: handleDialogError,
                        analyticsEvent: event
                    });
                }
            } else {
                if (props.onUpdateStatusMutation && (0, $7jTnu.fg)('relay-migration-issue-fields-status')) await props.onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: newStatus
                });
                else await (0, $keOPi.performIssuePostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                }, 'fields/status/src/services/status-service/status-service-new');
                (0, $gCeeo.fireTrackAnalytics)(event, 'issueTransition success', {
                    triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                    isModalOpen: false
                });
                (0, $7jTnu.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                success({
                    status: newStatus,
                    event: event
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $4ecf649628197b0c$export$25529a3376b831fd), error);
            (0, $gCeeo.fireTrackAnalytics)(event, 'issueTransition failed', {
                triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                isModalOpen: false
            });
            failure(error, event);
        }
    }, [
        cancel,
        failure,
        props,
        submit,
        success
    ]);
    const state = (0, $eJOHy.useMemo)(()=>({
            value: value,
            lastSavedValue: lastSavedValue,
            loading: loading,
            error: stateError
        }), [
        value,
        lastSavedValue,
        loading,
        stateError
    ]);
    const api = (0, $eJOHy.useMemo)(()=>({
            transitionStatus: transitionStatus,
            resetError: resetError
        }), [
        resetError,
        transitionStatus
    ]);
    return children({
        ...state,
        ...api
    });
};
var $bb299f6fd3832031$export$2e2bcd8739ae039 = $bb299f6fd3832031$var$StatusServiceNew;

});
const $4ecf649628197b0c$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $4ecf649628197b0c$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $4ecf649628197b0c$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $4ecf649628197b0c$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $4ecf649628197b0c$export$624e7abc8d9cada5 = 'ADMINISTER';

const $69adb038ef37db8c$export$a6eb4c39beb71474 = 'issue-transition-status-field';

parcelRegister("6gASS", function(module, exports) {

$parcel$export(module.exports, "default", () => $622673ba3c3979db$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $622673ba3c3979db$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.title",
        "defaultMessage": "We couldn't update the status"
    },
    description: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.description",
        "defaultMessage": "Check your network connection, then try reloading the issue."
    }
});
const $622673ba3c3979db$var$statusTransitionErrorFlag = (flagConfig)=>({
        messageId: `issue.fields.status.services.flags.transition-failed-error.flag.error.${flagConfig?.error?.name}`,
        messageType: 'transactional',
        type: 'error',
        title: $622673ba3c3979db$var$messages.title,
        description: $622673ba3c3979db$var$messages.description,
        isAutoDismiss: true,
        ...flagConfig || {}
    });
var $622673ba3c3979db$export$2e2bcd8739ae039 = $622673ba3c3979db$var$statusTransitionErrorFlag;

});

parcelRegister("kVuBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee8205860cbe92a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ee8205860cbe92a0$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.validation-error.main.title",
        "defaultMessage": "Transition failed"
    }
});
const $ee8205860cbe92a0$var$statusTransitionValidationErrorFlag = (description)=>({
        messageId: 'issue-field-status.services.flags.validation-error.flag.warning.error',
        messageType: 'transactional',
        type: 'warning',
        title: $ee8205860cbe92a0$var$messages.title,
        description: {
            id: 'issue-field.status.services.flags.validation-error.main.description',
            defaultMessage: description
        },
        isAutoDismiss: true
    });
var $ee8205860cbe92a0$export$2e2bcd8739ae039 = $ee8205860cbe92a0$var$statusTransitionValidationErrorFlag;

});



$parcel$global.rlb("ltVCh")
//# sourceMappingURL=status-service-new.b7609942.js.map
